import { useState } from "react";
import client from "../api/client";

export default function PayrollPage() {
  const [form, setForm] = useState({
    employeeId: "",
    payMonth: "",
    payYear: "",
    workingDays: 30,
    presentDays: 30,
    deductions: 0,
  });

  const [rows, setRows] = useState([]);

  const processPayroll = async () => {
    try {
      if (!form.employeeId) {
        alert("Employee Id is required");
        return;
      }

      if (!form.payMonth) {
        alert("Pay Month is required");
        return;
      }

      if (!form.payYear) {
        alert("Pay Year is required");
        return;
      }

      const payload = {
        companyId: Number(localStorage.getItem("companyId") || 0),
        employeeId: Number(form.employeeId),
        payMonth: Number(form.payMonth),
        payYear: Number(form.payYear),
        workingDays: Number(form.workingDays),
        presentDays: Number(form.presentDays),
        deductions: Number(form.deductions),
      };

      await client.post("/hr/payroll/process", payload);
      alert("Payroll processed successfully");
      await load();
    } catch (error) {
      console.error("Error processing payroll:", error);
      alert("Failed to process payroll");
    }
  };

  const load = async () => {
    try {
      if (!form.payMonth || !form.payYear) {
        alert("Please enter month and year");
        return;
      }

      const res = await client.get(
        `/hr/payroll?month=${form.payMonth}&year=${form.payYear}`,
      );

      setRows(res.data || []);
    } catch (error) {
      console.error("Error loading payroll:", error);
      alert("Failed to load payroll");
    }
  };

  return (
    <div>
      <h1>Payroll</h1>

      <div
        style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}
      >
        <input
          type="number"
          placeholder="Employee Id"
          value={form.employeeId}
          onChange={(e) => setForm({ ...form, employeeId: e.target.value })}
        />

        <input
          type="number"
          placeholder="Month"
          value={form.payMonth}
          onChange={(e) => setForm({ ...form, payMonth: e.target.value })}
        />

        <input
          type="number"
          placeholder="Year"
          value={form.payYear}
          onChange={(e) => setForm({ ...form, payYear: e.target.value })}
        />

        <input
          type="number"
          placeholder="Working Days"
          value={form.workingDays}
          onChange={(e) => setForm({ ...form, workingDays: e.target.value })}
        />

        <input
          type="number"
          placeholder="Present Days"
          value={form.presentDays}
          onChange={(e) => setForm({ ...form, presentDays: e.target.value })}
        />

        <input
          type="number"
          placeholder="Deductions"
          value={form.deductions}
          onChange={(e) => setForm({ ...form, deductions: e.target.value })}
        />

        <button onClick={processPayroll}>Process</button>
        <button onClick={load}>Load</button>
      </div>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>EmpCode</th>
            <th>Name</th>
            <th>Gross</th>
            <th>Deductions</th>
            <th>Net</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((r, i) => (
              <tr key={r.PayrollId || i}>
                <td>{r.EmpCode || r.empCode}</td>
                <td>
                  {r.FirstName || r.firstName} {r.LastName || r.lastName}
                </td>
                <td>{r.GrossSalary || r.grossSalary}</td>
                <td>{r.Deductions || r.deductions}</td>
                <td>{r.NetSalary || r.netSalary}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No payroll records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
